var map = {
	"./build1.jpg": "3404",
	"./honoral1.jpg": "25d6",
	"./partner1.jpg": "beb0",
	"./partner2.jpg": "8064",
	"./partner3.jpg": "d6e2",
	"./partner4.jpg": "6387",
	"./partner5.gif": "5676",
	"./team1.jpg": "a567",
	"./team2.jpg": "ffbd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2fa7";